(function () {
  const sliders = [];

  const initSliders = (section) => {
    const sliderEls = section.querySelectorAll(".js-product-tabs-slider");

    sliderEls.forEach((sliderEl) => {
      const swiperWrapper = sliderEl.querySelector(
        ".product-tabs__list--slider"
      );
      const slides = sliderEl.querySelectorAll(".product-tabs__item");

      if (!swiperWrapper || !slides || !slides.length) return;

      const tabId = sliderEl.dataset.productsTabId;
      const productsPerRow = Number(sliderEl.dataset.productsPerRow || 6);
      const productsPerRowMobile = Number(
        sliderEl.dataset.productsPerRowMobile || 1
      );

      const prevBtn = section.querySelector(
        `.product-tabs__navigation[data-products-tab-id="${tabId}"] .heading-group__navigation-button-prev`
      );
      const nextBtn = section.querySelector(
        `.product-tabs__navigation[data-products-tab-id="${tabId}"] .heading-group__navigation-button-next`
      );

      const paginationElement = section.querySelector(
        `.product-tabs__navigation[data-products-tab-id="${tabId}"] .heading-group__pagination`
      );
      const slidesPerViewMobile = productsPerRowMobile;
      const slidesPerView576 = productsPerRow > 1 ? 2 : 1;
      const slidesPerView990 =
        productsPerRow > 2 ? slidesPerView576 + 1 : slidesPerView576;
      const slidesPerView1100 = productsPerRow >= 4 ? 4 : productsPerRow;
      const slidesPerView1360 = productsPerRow;

      const sliderSettings = {
        slidesPerView: slidesPerViewMobile,
        slidesPerGroup: slidesPerViewMobile,
        spaceBetween: 4,
        speed: 800,
        watchSlideProgress: true,
        allowTouchMove: true,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
          disabledClass: "swiper-button-disabled",
        },
        pagination: {
          el: paginationElement,
          type: "fraction",
        },
        breakpoints: {
          576: {
            slidesPerView: slidesPerView576,
            slidesPerGroup: slidesPerView576,
          },
          990: {
            slidesPerView: slidesPerView990,
            slidesPerGroup: slidesPerView990,
          },
          1100: {
            slidesPerView: slidesPerView1100,
            slidesPerGroup: slidesPerView1100,
          },
          1360: {
            slidesPerView: slidesPerView1360,
            slidesPerGroup: slidesPerView1360,
          },
        },
      };

      const slider = new Swiper(sliderEl, sliderSettings);
      sliders.push(slider);
    });
  };

  const destroySliders = () => {
    sliders.forEach((slider) => {
      if (typeof slider.destroy === "function") {
        slider.destroy();
      }
    });
  };

  const toggleTab = (section) => {
    const tabsEls = section.querySelectorAll(".product-tabs__tab");
    const productsEls = section.querySelectorAll(".product-tabs__layout");
    const navigationEls = section.querySelectorAll(".product-tabs__navigation");

    const updateAriaState = () => {
      tabsEls.forEach((el) => {
        if (el.classList.contains("active")) {
          el.removeAttribute("aria-disabled");
        } else {
          el.setAttribute("aria-disabled", "true");
        }
      });
    };

    const onToggleTab = (event, tab) => {
      event.preventDefault();
      if (tab.classList.contains("active")) return;
      const tabId = tab.dataset.productsTabId;

      tabsEls.forEach((el) => {
        el.classList.remove("active", "button--tertiary");
        el.classList.add("button--simple");
      });

      productsEls.forEach((el) => {
        el.classList.remove("active");
      });

      navigationEls.forEach((el) => {
        el.classList.remove("active");
      });

      const productsActiveEl = section.querySelector(
        `.product-tabs__layout[data-products-tab-id="${tabId}"]`
      );
      const navigationActiveEl = section.querySelector(
        `.product-tabs__navigation[data-products-tab-id="${tabId}"]`
      );
      tab.classList.remove("button--simple");
      tab.classList.add("active", "button--tertiary");
      productsActiveEl.classList.add("active");
      navigationActiveEl.classList.add("active");
      updateAriaState();
    };

    tabsEls.forEach((tab) => {
      tab.addEventListener("click", (event) => onToggleTab(event, tab));

      tab.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          onToggleTab(event, tab);
        }
      });
    });
    updateAriaState();
  };

  const initProductsTabs = (section) => {
    if (!section || !section?.classList.contains("product-tabs-section")) {
      return;
    }

    const box = section.querySelector(".product-tabs");
    if (!box) return;

    const layout = box.dataset.layout || "grid";
    if (layout === "slider") {
      initSliders(box);
    } else {
      destroySliders();
    }

    toggleTab(box);
  };

  initProductsTabs(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initProductsTabs(event.target);
  });
})();
